import { useContext } from "react";

import { useAuth } from "../src/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export const CheckAuth = () => {
  const { authToken } = useAuth();
  if (authToken.length < 1) {
    return (
      <Navigate to={`/login?next=${window.location.pathname}`} replace={true} />
    );
  }
};

async function hasMediaAccess() {
  // Default response
  const result = {
    camera: false,
    microphone: false,
    supported: true,
  };

  // Some browsers (hi, Safari 👋) don't support navigator.permissions
  if (!navigator.permissions) {
    console.warn(
      "Permissions API not supported. Falling back to device check."
    );
    result.supported = false;
    return result;
  }

  try {
    // Query permissions separately — some browsers require this split
    const [camStatus, micStatus] = await Promise.all([
      navigator.permissions.query({ name: "camera" }),
      navigator.permissions.query({ name: "microphone" }),
    ]);

    result.camera = camStatus.state === "granted";
    result.microphone = micStatus.state === "granted";
  } catch (err) {
    // Fallback for Safari (throws instead of returning "prompt")
    console.warn("Permissions query failed:", err);
    result.supported = false;
  }

  return result;
}

async function hasMediaAccessFallback() {
  const result = { camera: false, microphone: false };

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();

    for (const device of devices) {
      if (device.kind === "videoinput" && device.label) result.camera = true;
      if (device.kind === "audioinput" && device.label)
        result.microphone = true;
    }
  } catch (err) {
    console.warn("Device enumeration failed:", err);
  }

  return result;
}

export async function detectMediaAccess() {
  const base = await hasMediaAccess();

  if (!base.supported) {
    const fallback = await hasMediaAccessFallback();
    return { ...base, ...fallback };
  }

  return base;
}

export const capitalize = (s: string) =>
  s
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
